import { render, staticRenderFns } from "./UserID.vue?vue&type=template&id=4d29d372&"
import script from "./UserID.vue?vue&type=script&lang=js&"
export * from "./UserID.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports